export const gettingStartedPage = () =>
  import("./GettingStartedPage").then((m) => ({ Component: m.GettingStartedPage }));
